import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { key: String };

  connect() {
    const key = `timehead:punch:${this.keyValue}`;
    let seen = false;
    try { seen = sessionStorage.getItem(key) === "shown"; sessionStorage.setItem(key, "shown"); } catch (_) { /* Receipt remains useful without storage. */ }
    if (!seen && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.element.classList.add("is-revealing");
      this.timer = setTimeout(() => this.element.classList.remove("is-revealing"), 1100);
    }
  }

  dismiss() { this.element.hidden = true; }
  disconnect() { clearTimeout(this.timer); this.element.classList.remove("is-revealing"); }
}
